export const UPLOAD_REQUEST = "UPLOAD_REQUEST";
export const UPLOAD_REQUEST_SUCCESS = "UPLOAD_REQUEST_SUCCESS";
export const UPLOAD_REQUEST_ERROR = "UPLOAD_REQUEST_ERROR";

export const DELETE_REQUEST = "DELETE_REQUEST";
export const DELETE_REQUEST_SUCCESS = "DELETE_REQUEST_SUCCESS";
export const DELETE_REQUEST_ERROR = "DELETE_REQUEST_ERROR";

